import { ErrorIcon, ErrorMessageWrapper, ErrorText } from "./ErrorMessage.styled";

interface ErrorMessageProps {
    message: string
}

export const ErrorMessage = ({message}: ErrorMessageProps) => {
    return(
        <ErrorMessageWrapper>
            <ErrorIcon />
            <ErrorText>{message}</ErrorText>
        </ErrorMessageWrapper>
    );
}